import { ScriptParams } from "./script-loader.model";

export function loadScript(params: ScriptParams): Promise<Event | void> {
	return new Promise<Event | void>((resolve, reject) => {
		if (typeof document === "undefined") {
			reject(
				new Error(
					`Dynamic script loading failed for ${params.id}. Script loading is not supported on the server.`
				)
			);
			return;
		}

		if (hasScript(params.id)) {
			resolve();
			return;
		}

		const script = document.createElement("script");
		script.src = params.src;
		script.id = params.id;
		if (params.type) {
			script.type = params.type;
		}
		script.onload = resolve;
		script.onerror = reject;

		const attributes = params.attributes;
		if (attributes) {
			Object.keys(attributes).forEach((key) => script.setAttribute(key, attributes[key]));
		}

		const head = document.querySelector("head");
		if (head) {
			head.appendChild(script);
		}
	});
}

export function hasScript(scriptId: string): boolean {
	return typeof document !== "undefined" && !!document.querySelector(`script#${scriptId}`);
}

export function cleanScript(id: string) {
	if (typeof document === "undefined") {
		return;
	}

	const existingScript = document.querySelector(`script#${id}`);

	if (existingScript) {
		existingScript.remove();
	}
}
